import { AccessPermissionsEnum } from '@/router/constants';
import wallet from './wallet';

function load(component) {
  return () => import(`@/views/loyalty/${component}.vue`);
}
const ViewLoyalties = load('ViewLoyalties');
const QViewLoyalties = load('QViewLoyalties');
const ProgramSelection = load('loyaltyTab/ProgramSelection');
const QProgramSelection = load('loyaltyTab/QProgramSelection');
const Bonus = load('loyaltyTab/Bonus');
const QBonus = load('loyaltyTab/QBonus');
const Discount = load('loyaltyTab/Discount');
const QDiscount = load('loyaltyTab/QDiscount');

export default [
  {
    path: 'loyalty',
    name: 'loyalty',
    component: ViewLoyalties,
    // redirect: { name: 'wallet' },
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_PSELECTION],
      newComponent: QViewLoyalties,
      icon: 'trophy',
    },
    children: [
      ...wallet,
      {
        path: 'pselection',
        name: 'pselection',
        component: ProgramSelection,
        meta: {
          requiresAuth: true,
          showInMenu: true,
          menuItems: 'leftSideMenu.pselection',
          newComponent: QProgramSelection,
          icon: 'q-gift',
        },
      },
      {
        path: 'pselection/bonus',
        name: 'bonus',
        component: Bonus,
        meta: {
          requiresAuth: true,
          icon: 'trophy',
          menuItems: 'leftSideMenu.pselection',
          newComponent: QBonus,
        },
      },
      {
        path: 'pselection/discount',
        name: 'discount',
        component: Discount,
        meta: {
          requiresAuth: true,
          icon: 'trophy',
          menuItems: 'leftSideMenu.pselection',
          newComponent: QDiscount,
        },
      },
    ],
  },
];
